import SelectItem from "@/models/components/inputs/selectItem";
import i18n from "@/plugins/i18n";
import { filterCapitalize } from "@/filters/capitalize";

export enum USER_TYPE {
  NotSelected = 0,
  Manual = 1,
  Auto = 2,
  Export = 3,
  Integration = 4,
}

export const userTypeSelectItems = [
  { text: filterCapitalize(i18n.t("notSet")), value: USER_TYPE.NotSelected } as SelectItem,
  { text: filterCapitalize(i18n.t("manual")), value: USER_TYPE.Manual } as SelectItem,
  { text: filterCapitalize(i18n.t("automat")), value: USER_TYPE.Auto } as SelectItem,
  { text: filterCapitalize(i18n.t("export")), value: USER_TYPE.Export } as SelectItem,
  { text: filterCapitalize(i18n.t("integration")), value: USER_TYPE.Integration } as SelectItem,
];
